import { parseJalaliDateKey, todayJalali } from './jalali';

export function isPastCalendarDay(dateKey: string | null | undefined, today = todayJalali()): boolean {
  const date = dateKey ? parseJalaliDateKey(dateKey) : null;
  if (!date) return false;
  return date.year * 10000 + date.month * 100 + date.day < today.year * 10000 + today.month * 100 + today.dat;
}
